import { EiaMain, EiaWeekly } from './EIA'
import { Fixtures } from './Fixtures'
import { Flows } from './Flows'
import { Cftc, OpenInterest } from './OpenInterest'
import { Storage } from './Storage'
import { PortRisk } from './Port'
import { CrudeRank } from './CrudeRank'
import { MarketWrap } from './MarketWrap'

export { CrudeRank, Cftc, EiaMain, EiaWeekly, Storage, Fixtures, Flows, OpenInterest, PortRisk, MarketWrap }
export default { CrudeRank, Cftc, EiaMain, EiaWeekly, Storage, Fixtures, Flows, OpenInterest, PortRisk, MarketWrap }